import gql from 'graphql-tag';
import { CommentFragments } from '@getaccept/lib-shared/src/contextual-comments/graphql/comment.fragments';

export class CommentMutations {
  static create = gql`
    mutation CreateComment($payload: CommentInput!) {
      createContextualComment(payload: $payload) {
        ...commentFragment
      }
    }
    ${CommentFragments.comment}
  `;

  static update = gql`
    mutation UpdateComment($payload: UpdateCommentInput!) {
      updateContextualComment(payload: $payload)
    }
  `;

  static createReply = gql`
    mutation CreateReply($payload: CommentReplyInput!) {
      createContextualCommentReply(payload: $payload) {
        ...replyFragment
      }
    }
    ${CommentFragments.reply}
  `;

  static readComment = gql`
    mutation ReadComment($commentId: String!) {
      setContextualCommentReadBy(commentId: $commentId)
    }
  `;

  static readReply = gql`
    mutation ReadReply($replyId: String!, $commentId: String!) {
      setContextualCommentReplyReadBy(replyId: $replyId, commentId: $commentId)
    }
  `;

  static readCommentsAndReplies = gql`
    mutation ReadCommentsAndReplies($payload: SetContextualCommentAndRepliesReadbyInput!) {
      setContextualCommentsAndRepliesReadBy(payload: $payload)
    }
  `;
}
